import { scaleThreshold } from '@visx/scale'

import { StateVariantFillStyles, StateVariantFillValues, StateVariants } from '../../../../../types/types'
import { DivergentColorOptions, QualitativeColorOptions } from '../../theme'

export const progressScaleToColorClassStyles: StateVariantFillStyles = {
    positive: 'fill-chart-divergent-lowmid',
    warning: 'fill-chart-divergent-high',
    critical: 'fill-chart-divergent-high',
    disabled: 'fill-chart-qualitative-13-primary',
}

export const progressScaleToColorValue: StateVariantFillValues = {
    positive: DivergentColorOptions.lowmid,
    warning: DivergentColorOptions.high,
    critical: DivergentColorOptions.critical,
    disabled: QualitativeColorOptions.gray,
}

// could make customizable
export const progressScaleStates = scaleThreshold<number, StateVariants>({
    domain: [0.5, 0.8],
    range: ['critical', 'warning', 'positive'],
})

export const slotScaleStates = scaleThreshold<number, StateVariants>({
    domain: [1, 1.01],
    range: ['positive', 'warning', 'critical'],
})
